import React from 'react'
import SimpleHero from '../../components/SimpleHero/SimpleHero'
import FeatureList from '../../components/Minimal/FeatureList'
import hidden from "../../assets/images/hidden.png";
import hidden3 from "../../assets/images/mobile-banking.png";
import hiddens from "../../assets/images/piggy-bank.png";
import savingsImg from "../../assets/images/saving.png";
import { CUSTOMER_PORTAL_URL } from '../../constants/links';

const Savings = () => {
  return (
    <div>
      <SimpleHero
        title="Save simply and automatically"
        subtitle="High‑yield savings with no monthly fees and easy automation."
        primaryLabel="Open an account"
        primaryHref={CUSTOMER_PORTAL_URL}
        variant="sofi"
        imageSrc={savingsImg}
        imageAlt="Savings preview"
        imageOn="right"
        tiltImage
        badges={["High yield","No fees","Mobile saves"]}
      />
      <FeatureList
        items={[
          { icon: hiddens, title: 'High‑yield APY', desc: 'Grow faster with automatic saves.' },
          { icon: hidden, title: 'No monthly fees', desc: 'No surprises—keep more of your savings.' },
          { icon: hidden3, title: 'Mobile saves', desc: 'Set goals, track progress on the go.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/contact">Ask About Rates</a>
          <a className="btn btn-gn-primary" href="tel:+17736242000">Call Us</a>
        </div>
      </section>
    </div>
  )
}

export default Savings